import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import { cn } from "@/lib/utils";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

interface Spec {
  label: string;
  value: string;
}

/** The long-form content, full width under the configurator rather than crammed beside it. */
export function ProductDetailsTabs({
  description,
  specs,
  className,
}: {
  description?: string;
  specs: Spec[];
  className?: string;
}) {
  const hasDescription = Boolean(description?.trim());
  const hasSpecs = specs.length > 0;
  if (!hasDescription && !hasSpecs) return null;

  return (
    <section className={cn(className)} aria-label="Detail produk">
      <Tabs defaultValue={hasDescription ? "deskripsi" : "spesifikasi"}>
        <TabsList>
          {hasDescription && <TabsTrigger value="deskripsi">Deskripsi</TabsTrigger>}
          {hasSpecs && <TabsTrigger value="spesifikasi">Spesifikasi</TabsTrigger>}
        </TabsList>
        {hasDescription && (
          <TabsContent value="deskripsi">
            {/* Flows into up to three columns as width allows, so long copy
                uses the page instead of a narrow strip down its left side. */}
            <div className="product-markdown columns-1 gap-10 leading-relaxed md:columns-2 lg:columns-3">
              <ReactMarkdown remarkPlugins={[remarkGfm]} skipHtml>
                {description}
              </ReactMarkdown>
            </div>
          </TabsContent>
        )}
        {hasSpecs && (
          <TabsContent value="spesifikasi">
            <dl className="max-w-3xl divide-y divide-ink/10">
              {/* Keyed by position, not by label: labels are operator-authored
                  free text with nothing stopping two rows sharing one. */}
              {specs.map((s, i) => (
                <div key={i} className="flex justify-between gap-6 py-3 text-sm">
                  <dt className="text-ink/60">{s.label}</dt>
                  <dd className="text-right font-medium">{s.value}</dd>
                </div>
              ))}
            </dl>
          </TabsContent>
        )}
      </Tabs>
    </section>
  );
}
